import {
  Activity,
  Clapperboard,
  Heart,
  Home,
  Library,
  Lock,
  Search,
  Settings,
  Users,
  type LucideIcon,
} from 'lucide-react';

/**
 * The application's navigation, declared once.
 *
 * `status` is honest about what exists. A destination that is not built yet is
 * shown as upcoming rather than routed to an empty screen, because an
 * interface that navigates somewhere blank is worse than one that says not
 * yet.
 */
export interface NavDestination {
  readonly to: string;
  readonly label: string;
  readonly icon: LucideIcon;
  readonly status: 'ready' | 'upcoming';
  /** Where in the build this destination arrives, shown on hover. */
  readonly arrivesIn?: string;
}

export const PRIMARY_NAV: readonly NavDestination[] = [
  { to: '/', label: 'Home', icon: Home, status: 'ready' },
  { to: '/browse', label: 'Find a film', icon: Search, status: 'ready' },
  { to: '/library', label: 'Library', icon: Library, status: 'ready' },
  { to: '/together', label: 'Watch Together', icon: Users, status: 'ready' },
  { to: '/private', label: 'Private Viewing', icon: Lock, status: 'ready' },
];

export const SECONDARY_NAV: readonly NavDestination[] = [
  { to: '/library?favorites=1', label: 'Favorites', icon: Heart, status: 'ready' },
  { to: '/activity', label: 'Activity', icon: Activity, status: 'upcoming', arrivesIn: 'the rooms phase' },
  { to: '/settings', label: 'Settings', icon: Settings, status: 'ready' },
];

export { Clapperboard };
